import $ from "jquery";
import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import { Button, Dropdown, Input } from 'semantic-ui-react';

import Loading from '../../loadings';
import Server from '../../../functions/server';

export default class ViewMachine extends React.Component {

    state = {
        data: [], machine: []
    }

    getMachine = () => {
        this.getMachineServiceType();
        let context = this;
        this.setState({ load: true, message: 'getting customer!!!' })
        $.ajax({
            data: { 'id': context.props.item.id }, type: 'POST',
            url: Server()+'machinecustomer/GetMachine.php',
            success: function(data) {
                console.log(data);
                try {
                    data = JSON.parse(data);
                    context.setState({ data, load: false, viewMachine: true });
                } catch (e) {
                    alert('Error')
                    context.setState({ load: false });
                }
            },
            error: function(e) {
                alert('Try again!!')
                context.setState({ load: false });
            }
        });
    }


    getMachineServiceType = () => {
        let context = this;
        $.ajax({
            data: { 'id': context.props.item.id }, type: 'POST',
            url: Server()+'machinecustomer/GetmachineServiceType.php',
            success: function(data) {
                console.log(data);
                try {
                    data = JSON.parse(data);
                    context.setState({ machine: data, load: false, viewMachine: true });
                } catch (e) {
                    alert('Error')
                    context.setState({ load: false });
                }
            },
            error: function(e) {
                alert('Try again!!')
                context.setState({ load: false });
            }
        });
    }

    editmaster = () => {
        let context = this;
        let { masterid, machineno } = this.state;
        this.setState({ load: true, message: 'Edit Machine Number!!!' })
        $.ajax({
            data: { masterid, machineno }, type: 'POST',
            url: Server()+'machinecustomer/EditMachieNo.php',
            success: function(data) {
                console.log(data);
                if (data == 1) {
                    context.getMachine();
                    context.setState({ load: false, machineEditDialog: false, machineno: '' })
                }
                else {
                    alert('Error')
                    context.setState({ load: false })
                }
            },
            error: function(e) {
                alert('Try again!!')
                context.setState({ load: false });
            }
        });

    }

    submit = () => {
        let context = this;
        let { addmachine, machineno } = this.state;
        let machine = addmachine.split('->')[1];
        let servicetype = addmachine.split('->')[0];
        let machinename = addmachine.split('->')[2];
        let servicetypename = addmachine.split('->')[3];
        this.setState({ load: true, message: 'getting customer!!!' })
        // alert(JSON.stringify({ machine, servicetype, machinename, servicetypename, 'id': context.props.item.id }));
        // return;
        $.ajax({
            data: { machine, servicetype, machinename, machineno, servicetypename, 'id': context.props.item.id }, type: 'POST',
            url: Server()+'machinecustomer/AddMachineAndServiceType.php',
            success: function(data) {
                console.log(data);
                if (data == 1) {
                    context.setState({ load: false, machineAddDialog: false })
                    context.getMachine();
                }
                else {
                    alert('Error')
                    context.setState({ load: false })
                }
            },
            error: function(e) {
                alert('Try again!!')
                context.setState({ load: false });
            }
        });
    }

    selectMachine = (f, { value }) => {
        this.setState({ addmachine: value })
    }


    machineOption = () => {
        let machine = this.state.machine;
        let data = this.state.data;
        let option = [];
        machine.map((c) => {
            option.push({ key: c.machine+"->"+c.name, text: c.machine+"->"+c.name, value: c.id+"->"+c.machineid+"->"+c.machine+"->"+c.name })
        })
        return option;
    }

    handleChange = name => event => {
        this.setState({
            [name]: event.target.value,
        });
    };
    

    render() {
        let { data } = this.state;
        let machineOption = this.machineOption(); 
        let i = 1;
        return (
            <div>
                <u onClick={this.getMachine} style={{cursor: 'pointer', color: 'blue'}}>View Machine</u>
                <Loading load={this.state.load} message={this.state.message} />

                <Dialog fullWidth={true} maxWidth={'md'} open={this.state.viewMachine} 
                    onClose={ () => { this.setState({ viewMachine: false }) }} 
                    aria-labelledby="max-width-dialog-title">
                    <DialogTitle id="max-width-dialog-title">View Machine</DialogTitle>
                    <DialogContent>
                        <table id="table" width="100%">
                            <tr>
                                <td id="tableheader"><center>Sino</center></td>
                                <td id="tableheader"><center>Machine No</center></td>
                                <td id="tableheader"><center>Machine</center></td>
                                <td id="tableheader"><center>Service Type</center></td>
                                <td id="tableheader"><center>Action</center></td>
                            </tr>
                            {
                                data.map((c) => {
                                    return (
                                        <tr>
                                            <td><center>{i++}</center></td>
                                            <td>{c.machine_no}</td>
                                            <td>{c.machinename}</td>
                                            <td>{c.servicetype}</td>
                                            <td onClick={ () => this.setState({ machineEditDialog: true, machineno: c.machine_no, masterid: c.masterid })}>Edit</td>
                                        </tr>
                                    )
                                })
                            }
                        </table>
                        <center>
                            <br/>
                            <Button onClick={ () => { this.setState({ machineAddDialog: true }) }}>
                                Add Machine
                            </Button>
                        </center>
                        <Dialog fullWidth={true} maxWidth={'sm'}
                            open={this.state.machineAddDialog} 
                            onClose={ () => { this.setState({ machineAddDialog: false }) }} aria-labelledby="max-width-dialog-title">
                            <DialogTitle id="max-width-dialog-title">Add Machine </DialogTitle>
                            <DialogContent>
                                Machine Number<br/>
                                <Input value={this.state.machineno} style={{fontSize: 12}} 
                                    onChange={this.handleChange('machineno')} fluid  />
                                <br/><br/>Select Machine
                                <Dropdown placeholder='Machine' style={{width: '100%'}} 
                                    onChange={this.selectMachine} 
                                    search selection 
                                    options={machineOption} value={this.state.addmachine} />
                                <br/><br/>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={ () => { this.setState({ machineAddDialog: false }) }} color="primary">Close</Button>
                                <Button onClick={this.submit} color="primary">Submit</Button>
                            </DialogActions>
                        </Dialog>


                        <Dialog fullWidth={true} maxWidth={'sm'}
                            open={this.state.machineEditDialog} 
                            onClose={ () => { this.setState({ machineEditDialog: false }) }} aria-labelledby="max-width-dialog-title">
                            <DialogTitle id="max-width-dialog-title">Add Machine </DialogTitle>
                            <DialogContent>
                                Machine Number<br/>
                                <Input value={this.state.machineno} style={{fontSize: 12}} 
                                    onChange={this.handleChange('machineno')} fluid  />
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={ () => { this.setState({ machineAddDialog: false }) }} color="primary">Close</Button>
                                <Button onClick={this.editmaster} color="primary">Submit</Button>
                            </DialogActions>
                        </Dialog>

                    </DialogContent>
                    <DialogActions>
                        <Button onClick={ () => { this.setState({ viewMachine: false }) }} 
                        color="primary">Close</Button>
                    </DialogActions>
                </Dialog>
                
            </div>
        );
    }

}